<template>
    <section id="iframe" class="iframe blue-grey lighten-5">
        <div class="container">
            <div class="embed-container">
                <img src="/assets/images/loading.jpg" v-if="showLoading" class="loading-img">
                <div v-if="showLoading" class="lds-ripple"><div></div><div></div></div>
                <iframe
                    v-show="!showLoading"
                    :src="iframeVideoURL"
                    width="0" 
                    height="0" 
                    scrolling="no"
                    frameborder="0"
                    allowtransparency="true"
                    allowfullscreen="true"
                    v-on:load="iframeLoaded"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                ></iframe>
            </div>
            <div class="row" v-show="!showLoading">
                <div class="col s12 sermon-details">
                    <div class="col s12 m12 l8">
                        <div class="heading">
                            <span v-if="sermon.Status == 'LIVE'">TODAY'S SERMON</span>
                            <span v-else-if="sermon.RowNumber == '1'">LATEST SERMON</span>
                            <span v-else>SERMON</span></div>
                        <div class="title">{{sermon.Title}}</div>
                    </div>
                    <div class="col s12 m12 l4 speaker-date">
                        <div class="speaker">{{sermon.Speaker}}</div>
                        <div class="date">
                            {{sermon.StreamDateFormatted}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import ENV from '../../constants/Environment.js';

export default {
    name: "Iframe",
    props: ['sermon'],
    data: function() {
        return {   
            facebook: ENV.FACEBOOK_LINK, 
            facebookLive: ENV.FACEBOOK_LIVE_LINK,
            showLoading: true,
            iframeVideoURL: ""
        }
    },
    created: function() {},
    methods: {
        iframeLoaded: function() {
            // alert('')
        }
    },
    watch: {
        sermon: {
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            deep: true,
            handler (val) {
                var self = this;
                self.showLoading = true;
                if (val.RedirectURL != "" && val.RedirectActive == "1" && val.AltVideoID == "") {
                     window.open(val.RedirectURL, '_blank');
                }

                // if (val.VideoID == "") {
                //     window.location.href = this.facebookLive;
                // }

                setTimeout(function() {
                    if (val.VideoID != "" && val.AltVideoID == "") {
                        self.iframeVideoURL = 'https://www.facebook.com/plugins/video.php?href=' + self.facebook + '/videos/' + val.VideoID + '/&show_text=0';
                    }
                    else {
                        self.iframeVideoURL = 'https://www.youtube.com/embed/' + val.AltVideoID;
                    }
                    self.showLoading = false;
                }, 5000)
            }
        }
    }
};
</script>

<style scoped>
    
	section {
		padding: 4rem 0 2rem 0;
	}
	.embed-container {
		position: relative;
		padding-bottom: 56.25%;
		height: 0;
		overflow: hidden;
        max-width: 100%;
        /* min-height: 725px; */
	}
	.embed-container iframe,
	.embed-container object,
	.embed-container embed {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
    
    .loading-img {
        width: 100%;
    }
    
    .not-loading {
        margin-top: 3rem;
    }

    .sermon-details {
        margin-top: 1rem;
        padding: 0;
    }

    .sermon-details .col {
        padding: 0;
    }

    .sermon-details .heading {
        font-size: 1rem;
        line-height: 1;
        text-transform: uppercase;
    }

    .sermon-details .title {
        margin-bottom: .25rem;
        font-size: 1.75rem;
        line-height: 1.25;
        font-family: NewhouseDTCond-ExtBold;
    }

    .sermon-details .speaker {
        font-size: 1rem;
        line-height: 1.25;
    }

    .sermon-details .date {
        font-size: 1rem;
        line-height: 1.25;
    }

    .sermon-details .speaker-date {
        text-align: right;
    }

    @media (max-width: 992px) {
        .sermon-details .speaker-date {
            text-align: left;
        }
    }
    .lds-ripple {
        position: absolute;
        z-index: 3;
        right: 0;
        left: 0;
        top: calc(100% - 120px);
        margin-left: auto;
        margin-right: auto;
    }
</style>